import { render } from "./AllProductPrices.vue?vue&type=template&id=1910d6ce&scoped=true"
import script from "./AllProductPrices.vue?vue&type=script&lang=js"
export * from "./AllProductPrices.vue?vue&type=script&lang=js"

import "./AllProductPrices.vue?vue&type=style&index=0&id=1910d6ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1910d6ce"]])

export default __exports__